<template>
    <modal
        :exibir="exibirModal"
        :titulo="titulo"
        largura="500"
        @fecharModal="fecharModal"
    >
        <template v-slot:conteudo>
            <div v-if="exibirModal">
                <div v-if="isFormPrincipal" class="flex flex-column align-center justify-center" style="padding-top: 30px">
                    <div class="text-center">
                        Escolha o tipo de assinatura
                    </div>

                    <div class="d-flex justify-center mt-4" style="gap: 20px">
                        <botao-primario
                            esconder-icone
                            class="botao-assinatura"
                            texto-botao="ELETRÔNICA"
                            @click="() => titulo = tituloAssinaturaEletronica"
                        />

                        <botao-primario
                            esconder-icone
                            class="botao-assinatura"
                            texto-botao="DIGITAL"
                            @click="titulo = tituloAssinaturaDigital"
                        />
                    </div>
                </div>

                <AssinaturaEletronica
                    ref="AssinaturaEletronica"
                    v-else-if="isAssinaturaEletronica"
                    :nomeAnexo="nomeAnexo"
                    @cancelar="fecharModal"
                    @assinatura-realizada="$emit('assinatura-realizada')"
                />

                <AssinaturaDigital
                    ref="AssinaturaDigital"
                    v-else-if="isAssinaturaDigital"
                    :nomeAnexo="nomeAnexo"
                    @cancelar="fecharModal"
                    @assinatura-realizada="$emit('assinatura-realizada')"
                />
            </div>
        </template>

        <template v-slot:acoes>
            <div class="az-actions-form" v-if="!isFormPrincipal">
                <botao
                    esconder-icone
                    texto-botao="CANCELAR"
                    @click="fecharModal"
                />

                <botao-primario
                    esconder-icone
                    texto-botao="ASSINAR"
                    @click="tratarAssinar"
                />
            </div>
        </template>
    </modal>
</template>

<script>
    import Modal from '@/views/components/modal/Modal.vue'
    import BotaoPrimario from '@/views/components/botoes/BotaoPrimario.vue'
    import AssinaturaEletronica from './AssinaturaEletronica.vue'
    import AssinaturaDigital from './AssinaturaDigital.vue'
    import Botao from '@/views/components/botoes/Botao.vue'

    export default {
        name: 'ModalAssinarDocumento',
        components: {
            Botao,
            BotaoPrimario,
            Modal,
            AssinaturaEletronica,
            AssinaturaDigital,
        },
        data() {
            return {
                exibirModal: false,
                titulo: this.tituloAssinarDocumento,
                documento: null,
            }
        },
        computed: {
            tituloAssinarDocumento() {
                return 'Assinar Documento'
            },
            tituloAssinaturaEletronica() {
                return 'Assinatura Eletrônica'
            },
            tituloAssinaturaDigital() {
                return 'Assinatura Digital'
            },
            isFormPrincipal() {
                return this.titulo === this.tituloAssinarDocumento
            },
            isAssinaturaEletronica() {
                return this.titulo === this.tituloAssinaturaEletronica
            },
            isAssinaturaDigital() {
                return this.titulo === this.tituloAssinaturaDigital
            },
            nomeAnexo() {
                if (!this.documento.titulo) return '-'

                return this.documento.titulo
            },
            refFormulario() {
                if (this.isAssinaturaEletronica) return 'AssinaturaEletronica'

                if (this.isAssinaturaDigital) return 'AssinaturaDigital'

                return null
            }
        },
        created() {
            this.resetarFormulario()
        },
        methods: {
            abrirModal(doc) {
                this.documento = {...doc}
                this.exibirModal = true
            },
            fecharModal() {
                this.exibirModal = false
                this.resetarFormulario()
            },
            resetarFormulario() {
                this.documento = null
                this.titulo = this.tituloAssinarDocumento
            },
            validarRef() {
                if (!this.refFormulario) {
                    this.mostrarNotificacaoErro('Defina se a assinatura será digital ou eletrônica')
                    return false
                }

                return true
            },
            async tratarAssinar() {
                if (!this.validarRef()) return

                if (!await this.$refs[this.refFormulario].$validator._base.validateAll()) return

                await this.assinar()
            },
            async assinar() {
                this.$refs[this.refFormulario].assinar(this.documento)
            },
        }
    }
</script>

<style lang="stylus">
    .botao-assinatura button
        width: 130px !important
</style>
